import { ghMap } from "@/constants";
import type { MatkulGradeItem } from "@/types";

function template1(data: MatkulGradeItem): string {
    return `Kamu dapat nilai **${ghMap[data.grade]}** untuk **${data.name}** _(Kelas ${data.kelas}, Semester ${data.smtOrdinal})_.`;
}

function template2(data: MatkulGradeItem): string {
    return `Nilai kamu untuk **${data.name}** _(Kelas ${data.kelas} - Semester ${data.smtOrdinal})_ adalah **${ghMap[data.grade]}** ⭐.`;
}

function template3(data: MatkulGradeItem): string {
    return `Dulu kamu dapat nilai **${ghMap[data.grade]}** di matkul **${data.name}** _(Kelas ${data.kelas}, Semester ${data.smtOrdinal})_.`;
}

function template4(data: MatkulGradeItem): string {
    return `**${data.name}** _(Kelas ${data.kelas})_? Kamu dapat nilai **${ghMap[data.grade]}** tuh waktu _Semester ${data.smtOrdinal}_.`;
}

function template5(data: MatkulGradeItem): string {
    return `Berdasarkan catatan, nilaimu untuk **${data.name}** kelas **${data.kelas}** di _Semester ${data.smtOrdinal}_ adalah **${ghMap[data.grade]}**.`;
}

// Fallback: matkul ditemukan tapi belum ada catatan nilainya
function templateNotFound(matkul: string): string {
    return `⚠️ Belum ada data nilai tercatat untuk matkul **${matkul}**.`;
}

export function generateMyRateMatkulResponse(
    data: MatkulGradeItem | null,
    namaMatkul: string
): string {
    if (!data) {
        return templateNotFound(namaMatkul);
    }

    const templates = [template1, template2, template3, template4, template5];
    const chosen = templates[Math.floor(Math.random() * templates.length)];
    return chosen(data);
}